





























import { mapState } from "vuex";
import IconBase from "@/common/components/atoms/IconBase.vue";
import IconUserImage from "@/common/components/icons/IconUserImage.vue";
import IconTriangleRight from "@/common/components/icons/IconTriangleRight.vue";

import { Prop, Vue, Component } from "vue-property-decorator";
import globals from "@/general/store/modules/globals";

@Component({
  components: {
    IconBase,
    IconUserImage,
    IconTriangleRight
  }
})
export default class A01MessageListPanel extends Vue {
  @Prop({ type: Object, required: true }) message!: any;

  isSpScreenWidth = globals.isSpScreenWidth;

  get iconSize() {
    if (this.isSpScreenWidth) {
      return {
        user: 24,
        triangle: 8
      };
    } else {
      return {
        user: 36,
        triangle: 10
      };
    }
  }

  get date() {
    return this.$dayjs
      .utc(this.message.date)
      .locale("ja")
      .format("YYYY/MM/DD HH:mm");

    // const getDate = new Date();
    // const UTCDate = getDate.toUTCString();
    // const timeStamp = Date.parse(UTCDate);
    // const ConvertDate = new Date(timeStamp);
    // // const parsedDate = ConvertDate.toLocaleDateString();
    // const parsedDate =
    //   ConvertDate.getDate() +
    //   "/" +
    //   ("0" + (ConvertDate.getMonth() + 1)).slice(-2) +
    //   "/" +
    //   ConvertDate.getFullYear();

    // return parsedDate;
  }
}
